import _ from "lodash";

import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

interface SoundLevelType {
    id: number;
    level: number;
}

interface SoundsType {
    decibels: SoundType[];
    percentage: SoundType[];
    settings: any;
    groups: SoundGroup[];
    order: SoundsOrder;
}

export interface SoundType {
    id: number;
    level: SoundLevelType;
    sub_level_1: number;
    sub_level_2: number;
    sub_level_3: number;
}

export interface SoundGroup {
    id: number;
    events: string;
    game_type: string;
    group_description: string;
}

export interface SoundsOrder {
    key: string;
    direction: string;
}

function decibelsInfo(state: SoundType[] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_DECIBELS_SUCCESS:
            let response = action.payload.results;
            return Object.assign([], state, response);
        default:
            return state;
    }
}

function percentageInfo(state: SoundType[] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_PERCENTAGE_SUCCESS:
            let response = action.payload.results;
            return Object.assign([], state, response);
        default:
            return state;
    }
}

function soundSettings(state: any = [], action: Action) {
    let matchIndex = -1;
    switch (action.type) {
        case ConfigurationsActionTypes.GET_SOUNDS_SUCCESS:
            return Object.assign([], state, action.payload);
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_LEVEL:
            matchIndex = _.findIndex(state, {
                id: action.payload.soundGroupId,
                identifier: action.payload.gameInstanceId
            });

            if (matchIndex !== -1) {
                state[matchIndex] = {
                    ...state[matchIndex],
                    level: action.payload.level
                };
            }

            return Object.assign([], state, state);
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_SUB_LEVEL:
            matchIndex = _.findIndex(state, {
                id: action.payload.soundGroupId,
                identifier: action.payload.gameInstanceId
            });

            if (matchIndex !== -1) {
                state[matchIndex] = {
                    ...state[matchIndex],
                    sub_level: state[matchIndex].sub_level_enabled
                        ? action.payload.sublevel
                        : null
                };
            }
            return Object.assign([], state, state);
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_BULK:
            action.payload.sounds.map(sound => {
                const soundMatchIndex = _.findIndex(state, {
                    id: sound.id,
                    identifier: sound.identifier
                });

                if (soundMatchIndex !== -1) {
                    state[soundMatchIndex] = {
                        ...sound
                    };
                }
            });

            return Object.assign([], state, state);
        default:
            return state;
    }
}

function soundGroups(state: SoundGroup[] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_SOUNDS_GROUPS_SUCCESS:
            let response = action.payload.results;
            return Object.assign([], state, response);
        default:
            return state;
    }
}

function soundsOrder(
    state: SoundsOrder = {
        key: "description",
        direction: "asc"
    },
    action: Action
) {
    switch (action.type) {
        case ConfigurationsActionTypes.REORDER_SOUNDS_SUCCESS:
            return {
                ...action.payload
            };
        default:
            return state;
    }
}

export function sounds(
    state: SoundsType = {
        decibels: [],
        percentage: [],
        settings: [],
        groups: [],
        order: {
            key: "description",
            direction: "asc"
        }
    },
    action: Action
) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_SOUNDS_GROUPS_SUCCESS:
            return Object.assign({}, state, {
                groups: soundGroups(state.groups, action)
            });
        case ConfigurationsActionTypes.REORDER_SOUNDS_SUCCESS:
            return Object.assign({}, state, {
                order: soundsOrder(state.order, action)
            });
        case ConfigurationsActionTypes.GET_SOUNDS_SUCCESS:
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_LEVEL:
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_SUB_LEVEL:
        case ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_BULK:
            return Object.assign({}, state, {
                settings: soundSettings(state.settings, action)
            });
        case ConfigurationsActionTypes.GET_PERCENTAGE_SUCCESS:
            return Object.assign({}, state, {
                percentage: percentageInfo(state.percentage, action)
            });
        case ConfigurationsActionTypes.GET_DECIBELS_SUCCESS:
            return Object.assign({}, state, {
                decibels: decibelsInfo(state.decibels, action)
            });
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return {
                decibels: [],
                percentage: [],
                settings: [],
                groups: [],
                order: {
                    key: "description",
                    direction: "asc"
                }
            };
        default:
            return state;
    }
}
